<dx-popup
  [title]="title"
  [(visible)]="visible"
  width="1000px"
  height="700px"
  [showCloseButton]="false"
  (onShown)="onShown()">
  <div *dxTemplate="let t = data; of: 'content'">
    <div class="loaderContent" style="height: 100%">
      @if (!this.isLoading2()) {
        <div style="height: 500px">
          <div>
            <dx-radio-group
              [dataSource]="options"
              displayExpr="name"
              valueExpr="value"
              [(value)]="option_selected"
              layout="horizontal">
            </dx-radio-group>
          </div>
          @if (option_selected === 'PBM') {
            <div style="margin-top: 20px; max-width: 420px">
              <div style="margin-bottom: 10px">
                Enter the letter code from your plea-by-mail document and the matching PIN.
              </div>
              <div style="display: flex; flex-direction: column; gap: 14px">
                <div>
                  <div style="margin-bottom: 4px">Letter Code</div>
                  <dx-text-box
                    #edtLetterCode
                    [(value)]="letter_code"
                    width="300px"
                    maxLength="25"
                    valueChangeEvent="keyup blur change focusout"
                  ></dx-text-box>
                </div>
                <div>
                  <div style="margin-bottom: 4px">PIN</div>
                  <dx-text-box
                    [(value)]="pin"
                    width="200px"
                    maxLength="15"
                    mode="password"
                    valueChangeEvent="keyup blur change focusout"
                    (onEnterKey)="onSubmit($event)"
                  ></dx-text-box>
                </div>
              </div>
            </div>
          }
          @if (option_selected === 'VC') {
            <div>[Video Conference Information]</div>
          }
        </div>
        <dx-toolbar style="margin-top: 20px">
          <dxi-item location="before">
            <dx-button
              #submitButton
              [tabindex]="1"
              text="Ok"
              (onClick)="onSubmit($event)"
            icon="../../../assets/images/Check_16x16.png"></dx-button>
          </dxi-item>
          <dxi-item location="before">
            <dx-button text="Cancel" type="danger" (onClick)="onCancel($event)"></dx-button>
          </dxi-item>
        </dx-toolbar>
      } @else {
        <app-loading-div></app-loading-div>
      }
    </div>
  </div>
</dx-popup>
